module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsSAAALEgHS3X78AAABG0lEQVRYhe2WP07DMBSHv1TsRMI7R6A3IEfwDdqO2dizdMAzTHgETkBuQI5QbsABsvQE7hBbsiIo/lPaxZ8UKZac9/tkWS+vMsaQilBaAt9j1+5Sa1wlp098AHugTi2wyBQAuM75+BQCWRSBIlAEikARKALBv2Oh9BKox64djuypgTXTjNCH1I05gWfgUyj9diR8AJ6Ah9CiMQIueDWX8MLvZnv/pIoZyYTSa+DVLt+BlX3/8sI3Y9f+j8APEnOiwgGqm8cXyXRkTehw+YtEcLi90D0gF8CSaa6TYc5ggzYp4RYJ3DqBJDyJ6GP3yRrLc4IdF++EReDiAv4lbITS2zPlNr6Aaz739jkXe2CojDGuMwU3ohPRj127OwATS1lDSMKMDwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download.png
// module id = pNWR
// module chunks = 1